document.querySelector("#process-images").addEventListener("click", async () => {
  const coverFile = document.querySelector("#cover-upload").files[0];
  const faceFile = document.querySelector("#face-upload").files[0];

  if (!coverFile || !faceFile) {
    alert("Please upload both images.");
    return;
  }

  const formData = new FormData();
  formData.append("cover", coverFile);
  formData.append("face", faceFile);

  // Call your backend
  const response = await fetch("https://your-backend.com/process-image", {
    method: "POST",
    body: formData
  });

  const data = await response.json();

  if (data.processedImageUrl) {
    document.querySelector("#preview").src = data.processedImageUrl;
  } else {
    alert("Image processing failed. Try again.");
  }
});
